import { createContext } from "react";

const WishListContext = createContext({});

export default WishListContext;
